import { t } from "../translates/translate"

/* Access — a leaf module, it drags nothing along */
import { isSuperAdmin, getRole } from "./access"

const getData = () => [
    { name: "dashboard", text: t("menu.dashboard"), link: "/", image: <img src="/images/home.png" alt="Home" /> },
    { name: "game", text: t("menu.game"), link: "/game", image: <img src="/images/spade.png" alt="Spade" /> },
    { name: "player", text: t("menu.player"), link: "/player", image: <img src="/images/user.png" alt="User" /> },
    { name: "studio", text: t("menu.studio"), link: "/studio", image: <img src="/images/light.png" alt="User" /> },
    { name: "bonus", text: t("menu.bonus"), link: "/bonus", image: <img src="/images/jackpot.png" alt="Chat" /> },
    { name: "message", text: t("menu.message"), link: "/message", image: <img src="/images/chat.png" alt="Chat" /> },
    {
        name: "transaction",
        text: t("menu.transaction"),
        link: "/transaction",
        image: (
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 3.75c0-.9.98-1.46 1.76-1.01l1.49.86 1.49-.86a1.17 1.17 0 0 1 1.17 0l1.49.86 1.49-.86a1.17 1.17 0 0 1 1.17 0l1.49.86 1.49-.86A1.17 1.17 0 0 1 19.5 3.75v16.5c0 .9-.98 1.46-1.76 1.01l-1.49-.86-1.49.86a1.17 1.17 0 0 1-1.17 0l-1.49-.86-1.49.86a1.17 1.17 0 0 1-1.17 0l-1.49-.86-1.49.86A1.17 1.17 0 0 1 4.5 20.25V3.75zM8 8.4a.9.9 0 0 0 0 1.8h8a.9.9 0 0 0 0-1.8H8zm0 5a.9.9 0 0 0 0 1.8h5a.9.9 0 0 0 0-1.8H8z"
                />
            </svg>
        ),
    },
    {
        name: "booking",
        text: t("menu.booking"),
        link: "/booking",
        image: (
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.75 2a.9.9 0 0 1 .9.9V4h6.7V2.9a.9.9 0 0 1 1.8 0V4H18a2.75 2.75 0 0 1 2.75 2.75v11.5A2.75 2.75 0 0 1 18 21H6a2.75 2.75 0 0 1-2.75-2.75V6.75A2.75 2.75 0 0 1 6 4h.85V2.9a.9.9 0 0 1 .9-.9zM5.05 10.5v7.75c0 .524.426.95.95.95h12a.95.95 0 0 0 .95-.95V10.5H5.05zm11.06 2.16a.9.9 0 0 1 .04 1.272l-4.2 4.4a.9.9 0 0 1-1.29.014l-2.3-2.3a.9.9 0 1 1 1.272-1.272l1.647 1.646 3.559-3.728a.9.9 0 0 1 1.272-.032z"
                />
            </svg>
        ),
    },
    { name: "space" },
    { name: "currency", text: t("menu.currency"), link: "/currency", image: <img src="/images/dollar.png" alt="Dollar" />, superadmin: true },
    { name: "card", text: t("menu.card"), link: "/card", image: <img src="/images/cards.png" alt="Cards" />, superadmin: true },
    { name: "dealer", text: t("menu.dealer"), link: "/dealer", image: <img src="/images/croupier.png" alt="Croupier" /> },
    {
        name: "pitboard",
        text: t("menu.pitboard"),
        action: "pitboard",
        roles: ["superadmin", "manager", "pitboss"],
        image: (
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2.25a9.75 9.75 0 1 0 0 19.5 9.75 9.75 0 0 0 0-19.5zm.9 4.65a.9.9 0 0 0-1.8 0V12c0 .3.15.58.4.75l3.6 2.4a.9.9 0 1 0 1-1.5l-3.2-2.13V6.9z"
                />
            </svg>
        ),
    },
    { name: "space" },
    { name: "manager", text: t("menu.managers"), link: "/manager", image: <img src="/images/permission.png" alt="Permission" />, superadmin: true },
    { name: "operator", text: t("menu.operators"), link: "/operator", image: <img src="/images/avatar.png" alt="Avatar" />, superadmin: true },
    {
        name: "rsg",
        text: t("menu.rsg"),
        link: "/rsg",
        image: (
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 1.5c-1.243 0-2.25 1.007-2.25 2.25v16.5c0 1.243 1.007 2.25 2.25 2.25h12c1.243 0 2.25-1.007 2.25-2.25V8.06a1.5 1.5 0 0 0-.44-1.06l-5.06-5.06a1.5 1.5 0 0 0-1.06-.44H6zm7 1.75v3.5a1 1 0 0 0 1 1h3.5L13 3.25zM7.5 12.25a.9.9 0 0 0 0 1.8h9a.9.9 0 0 0 0-1.8h-9zm0 4a.9.9 0 0 0 0 1.8h6a.9.9 0 0 0 0-1.8h-6z"
                />
            </svg>
        ),
        superadmin: true,
    },
    {
        name: "log",
        text: t("menu.log"),
        link: "/log",
        image: (
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.75 5.25c0-1.243 1.007-2.25 2.25-2.25h12c1.243 0 2.25 1.007 2.25 2.25v13.5c0 1.243-1.007 2.25-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V5.25zM7.5 7.4a.9.9 0 0 0 0 1.8h9a.9.9 0 0 0 0-1.8h-9zm0 3.7a.9.9 0 0 0 0 1.8h9a.9.9 0 0 0 0-1.8h-9zm0 3.7a.9.9 0 0 0 0 1.8h5a.9.9 0 0 0 0-1.8h-5z"
                />
            </svg>
        ),
        superadmin: true,
    },
]

/* ACCESS OF A ROW — Admins.access is the only source of truth */
const isAllowed = (item, admin) => {

    /* Superadmin Row */
    if (item.superadmin && !isSuperAdmin(admin)) {
        return false
    }

    /* Row Of Some Roles Only */
    if (item.roles && !item.roles.includes(getRole(admin))) {
        return false
    }

    return true
}

/* A DIVIDER NEVER OPENS A LIST, NEVER DOUBLES ITSELF AND NEVER CLOSES THE LIST */
const clean = (list) => list.filter((item, index) => {

    /* Check Divider */
    if (item.name !== "space") {
        return true
    }

    /* Check Neighbours */
    if (index === 0 || list[index - 1].name === "space") {
        return false
    }

    /* Send Result */
    return list.slice(index + 1).some((next) => next.name !== "space")
})

/* ROWS AN ADMIN REACHES — THE SIDEBAR AND THE MOBILE BAR READ THE VERY SAME LIST */
const getItems = (admin) => clean(getData().filter((item) => isAllowed(item, admin)))

export { getData, getItems, clean }
